export class GroupKey {
    constructor(
        public value: string,
        public display: string,
        public payload?: { [id: string]: any }
    ) {}
}
